import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import * as React from 'react';
import { classNames } from "../../utils/helpers";
import { Actionable } from "../actionable";
import { Icon } from "../icon";
import s from './Link.module.css';
export const Link = React.forwardRef(({ startIcon, endIcon, disabled, href, variant = 'underline', className, children, attributes, type, fullWidth, insetFocus, tabIndex, onClick, size = 'inherit', preventHoverOpacityChange, }, ref) => {
    const hasIcon = startIcon || endIcon;
    const rootClassNames = classNames(s.root, disabled && s['--disabled'], variant && s[`--variant-${variant}`], hasIcon && s['--with-icon'], size !== 'inherit' && s[`--size-${size}`], className);
    const style = Object.assign({}, (preventHoverOpacityChange && { '--st-text-hover-opacity': 1 }));
    const attrs = Object.assign(Object.assign({}, attributes), { style: Object.assign({}, style) });
    return (_jsxs(Actionable, { href: href, disabled: disabled, className: rootClassNames, attributes: Object.assign({ 'data-testid': 'st-link' }, attrs), type: type, fullWidth: fullWidth, insetFocus: insetFocus, tabIndex: tabIndex, onClick: onClick, ref: ref, children: [startIcon && (_jsx(Icon, { color: disabled ? 'on-disabled' : undefined, svg: startIcon, className: s['start-icon'] })), children, endIcon && (_jsx(Icon, { color: disabled ? 'on-disabled' : undefined, svg: endIcon, className: s['end-icon'] }))] }));
});
Link.displayName = 'Link';
